import environment from '#/environment/environment';
import {Land} from '@shareland/shareland-common';

const fetchLands = async (): Promise<Land[]> => {
  return fetch(`${environment.apiUrl}/lands`)
    .then(response => response.json())
    .then(json => json.data.lands);
};

export {fetchLands};
